import React from 'react';

/** A numeric PIN field: digits only, masked, wide tracking. */
export function PinInput({
  value,
  onChange,
  label,
  invalid,
  autoFocus,
  disabled,
  maxLength = 6
}: {
  value: string;
  onChange: (value: string) => void;
  label: string;
  invalid?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
  maxLength?: number;
}) {
  return <input type="password" inputMode="numeric" autoComplete="off" autoFocus={autoFocus} disabled={disabled} value={value} maxLength={maxLength} onChange={event => onChange(event.target.value.replace(/\D/g, '').slice(0, maxLength))} placeholder="••••" aria-label={label} aria-invalid={invalid ? true : undefined} className={`cz-num h-11 w-full rounded-lg border bg-surface px-3 text-center text-lg tracking-[0.5em] text-ink transition-colors duration-150 ease-out placeholder:tracking-[0.4em] placeholder:text-ink-subtle focus:outline-none disabled:bg-canvas disabled:text-ink-subtle ${invalid ? 'border-danger-700' : 'border-line-strong focus:border-brand-700'}`} data-id="element-3769" data-mp="24vp4k0j92w6s" />;
}